import { Owned } from 'app/model/base/named';
import { DataFlowFunction } from 'app/model/dataflow/dataflow-function';
import { DataFlow } from 'app/model/dataflow/dataflow';
import { FunctionPlainObject } from 'worker/app-workers/shared/plainObjects/function.plainObject';
import { DataFlowExpressionUtils } from '../../expression.util';

export class FunctionConvertor {
    constructor(protected functionObject: FunctionPlainObject, protected dataflow: DataFlow) {}

    public async convert(): Promise<DataFlowFunction> {
        const func = Owned.create<DataFlowFunction>(DataFlowFunction.MODEL, this.dataflow);
        func.name = this.functionObject.name;
        func.paramTypes = this.functionObject.paramTypes;
        func.returnType = this.functionObject.returnType;

        if (!!this.functionObject.className) {
            func.className = DataFlowExpressionUtils.extractStringConfigValue(this.functionObject.className);
        }

        if (!!this.functionObject.expression) {
            func.funcExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                this.functionObject.expression
            );
        }

        return func;
    }
}
